import React from 'react';
import { BrainIcon, SunIcon, MoonIcon, SmartphoneIcon, ClockIcon, HeartPulseIcon } from 'lucide-react';
export const ScienceSection = () => {
  return <section className="w-full bg-indigo-50 py-16 md:py-24" data-id="element-476">
      <div className="container mx-auto px-4 md:px-6" data-id="element-477">
        <div className="max-w-4xl mx-auto" data-id="element-478">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-10" data-id="element-479">
            The Science That Makes Sense
          </h2>
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-480">
            <div className="flex flex-col md:flex-row mb-8" data-id="element-481">
              <div className="md:w-1/2 md:pr-6" data-id="element-482">
                <p className="text-gray-700 mb-6" data-id="element-483">
                  Your body already makes melatonin—it's your natural "sleepy
                  time" hormone. When the sun sets, your brain should release
                  melatonin, signaling it's time to wind down. But modern life
                  disrupts this process:
                </p>
                <div className="grid grid-cols-1 gap-4 mb-6" data-id="element-484">
                  <div className="flex items-start" data-id="element-485">
                    <SmartphoneIcon className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" data-id="element-486" />
                    <p className="text-gray-700" data-id="element-487">
                      Blue light from screens tricks your brain into thinking
                      it's still daytime
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-488">
                    <HeartPulseIcon className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" data-id="element-489" />
                    <p className="text-gray-700" data-id="element-490">
                      Stress and irregular schedules throw off your internal
                      clock
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-491">
                    <ClockIcon className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" data-id="element-492" />
                    <p className="text-gray-700" data-id="element-493">
                      Age naturally reduces melatonin production
                    </p>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2 flex justify-center items-center mb-6 md:mb-0" data-id="element-494">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/48Fm4kD4bGE2pABqiDxBMd/Screenshot_2025-08-25_at_10.17.31_PM.png" alt="Melt-in-Your-Mouth Strips demonstration" className="rounded-lg shadow-md w-full max-w-xs" onError={e => {
                e.target.src = 'https://images.unsplash.com/photo-1544256718-3bcf237f3974?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80';
              }} data-id="element-495" />
              </div>
            </div>
            <p className="text-gray-700 mb-6" data-id="element-496">
              Sleeping pills ignore this system entirely. They use chemicals
              like zolpidem or diphenhydramine to force unconsciousness,
              bypassing your natural sleep mechanisms.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-497">
              Setu's Sleep Restore is different. It delivers 5mg of
              melatonin—the exact same molecule your body produces—in a
              convenient mint-flavored strip. Think of it as gentle support, not
              a chemical override.
            </p>
            <p className="text-indigo-700 font-medium text-lg" data-id="element-498">
              The result? You fall asleep naturally, cycle through proper sleep
              stages, and wake up the way nature intended.
            </p>
          </div>
          <div className="relative" data-id="element-499">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-500">
              <div className="w-1 h-full bg-indigo-200" data-id="element-501"></div>
            </div>
            <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-502">
              <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center" data-id="element-503">
                <div className="bg-red-100 rounded-full p-3 mb-4" data-id="element-504">
                  <SunIcon className="h-8 w-8 text-red-500" data-id="element-505" />
                </div>
                <h3 className="text-xl font-bold text-red-800 mb-2" data-id="element-506">
                  Sleeping Pills
                </h3>
                <img src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1769&q=80" alt="Sleeping pills in a container" className="rounded-lg shadow-sm w-full h-40 object-cover mb-4" onError={e => {
                e.target.src = 'https://images.unsplash.com/photo-1550572017-edd951b55104?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80';
              }} data-id="element-507" />
                <p className="text-gray-700" data-id="element-508">
                  Force your brain into unconsciousness, bypassing natural sleep
                  cycles and causing dependency
                </p>
              </div>
              <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center" data-id="element-509">
                <div className="bg-indigo-100 rounded-full p-3 mb-4" data-id="element-510">
                  <MoonIcon className="h-8 w-8 text-indigo-600" data-id="element-511" />
                </div>
                <h3 className="text-xl font-bold text-indigo-800 mb-2" data-id="element-512">
                  Setu Sleep Restore Strips
                </h3>
                <div className="bg-indigo-50 p-3 rounded-lg w-full h-40 flex items-center justify-center mb-4" data-id="element-513">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/og45cR6GEKB2RvPaD1aJ2B/Screenshot_2025-08-25_at_9.01.12_PM.png" alt="Sleep Restore Melatonin Strips" className="max-h-full rounded-lg" data-id="element-514" />
                </div>
                <p className="text-gray-700" data-id="element-515">
                  Supports your body's natural sleep hormone production for
                  restorative, healthy sleep with convenient mint-flavored
                  strips
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};